import React from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from 'components/Common/Tooltip/Tooltip';
import './CustomProgressBar.scss'

function CustomProgressBar({ show, value, styling = "", tooltip = false, queued = false }) {
  const darkMode = useSelector((state) => state.app.darkMode)

  return (
    <div className={`${darkMode ? "darkMode" : ""} p-0 m-0 w-100 custom-progress-bar`}>
      {tooltip ?
        <Tooltip
          placement='top'
          description={value === 0 ? "Waiting for process to begin..." : value + '%'}
          white={!darkMode}
        >
          <div className={`${show ? "show-progress-bar" : "hide-progress-bar"} progress ${styling}`} style={{ position: "relative", height: "5px", width: "95%" }}>
            <div
              className="progress-bar progress-bar-striped progress-bar-animated" 
              role="progressbar" aria-valuenow={`${value}`} aria-valuemin="0" aria-valuemax="100" 
              style={{width: `${value ?? "100"}%`}}
            >
            </div>
          </div>
        </Tooltip>
      :
        <div className={`${show ? "show-progress-bar" : "hide-progress-bar"} progress ${styling}`} style={{ position: "relative", height: "5px", width: "95%" }}>
          <div
            className="progress-bar progress-bar-striped progress-bar-animated" 
            role="progressbar" aria-valuenow={`${value}`} aria-valuemin="0" aria-valuemax="100" 
            style={{width: `${value ?? "100"}%`}}
          >
          </div>
        </div>
      }
    </div>
  )
}

export default CustomProgressBar;
